import { isBackendAgentStreamingParticipant } from '@databases/database-ai-first-creation-state';
import { type Participant } from '@databases/presence';

import { getAiFieldStreamingParticipants } from './get-ai-field-streaming-participants.ts';

interface GetRowCollaboratorColorOptions {
  participants: Participant[];
  recentCollaboratorColor: string | undefined;
  isAiFieldStreaming: boolean;
  isProgressivelyRevealed: boolean;
}

export const getEntryPresenceBorderColor = ({
  participants,
  recentCollaboratorColor,
  isAiFieldStreaming,
  isProgressivelyRevealed
}: GetRowCollaboratorColorOptions): string | undefined =>
  isProgressivelyRevealed
    ? participants.find(isBackendAgentStreamingParticipant)?.colorToken
    : isAiFieldStreaming
      ? getAiFieldStreamingParticipants({
          participants,
          shouldExcludeAiAgent: true
        })[0]?.colorToken
      : recentCollaboratorColor;
